<template>
  <main class="bui-about" :class="{en: globalLang === 'en' || globalLang === 'th' || globalLang === 'vi'}">
    <section class="contact-container">
      <section class="main-block">
        <section class="main-tit">
          <div class="tit-des">{{$t('about.des')}}</div>
          <span class="tit-slice"></span>
          <div class="tit-en-des" v-if="$area !== 'komoe-sea'">{{$t('about.enDse')}}</div>
        </section>
        <section class="main-con">
          <div class="con-tit" v-if="$area !== 'komoe-sea'">{{$t('about.hint')}}</div>
          <div class="con-block con-about" v-html="$t($area === 'komoe-sea'&&globalLang==='zh'?'about.article1':'about.article')"></div>
        </section>
      </section>
    </section>
  </main>
</template>
<script>
export default {
  name: "about-pc"
}
</script>
<style lang="scss" scoped>
@import "../../../../scss/common.scss";
.bui-about {
  margin: 0 auto;
  min-width: 1366px;
  max-width: 1920px;
  &.en {
    .main-tit {
      border: none;
      font-weight: bold;
    }
  }
}
.contact-container {
  height: 867px;
  background: url("../../img/bg_aboutus.png") center center no-repeat;
  background-size: 100% 100%;
}
.main-con {
  height: 100%;
  .con-about {
    font-size: 14px;
    line-height: 28px;
  }
}
</style>